import React, {Component} from "react";
import {List, Typography, LinearProgress, Hidden, GridListTile} from "@material-ui/core/";

import SimpleMediaCard from "../../components/SimpleMediaCard";
import CardGridList from "../../components/CardGridList"

import {ChannelRoutes} from "../../modal/channelRoutes";
import "./myChannels.css";

let MyChannels = class Unit extends Component {
  render() {
    return (
      <div>
        <Hidden mdUp>
          {/* This will appear in small screens */}
          <List>{populateList(ChannelRoutes)}</List>
        </Hidden>
        <Hidden smDown>
          {/* This will appear in big screens */}
          <CardGridList>
            {populateCards(ChannelRoutes)}
          </CardGridList>
        </Hidden>
      </div>
    );
  }
};

const populateCards = channels => {
  return Object.keys(channels).map((k, i) => {
    let el = channels[k];
    return <GridListTile key={i} cols={1} style={{
      height: 'auto'
    }}><SimpleMediaCard key={i} cardData={el}/></GridListTile>
  })
}

const populateList = channels => {
  return Object.keys(channels).map((k, i) => {
    let el = channels[k];
    return (
      <div key={i} className="my-channels-block">
        <div className="my-channel-icon">
          <img alt="my-channel-icon" src={el.icon}/>
        </div>
        <div className="my-channel-details-cntr">
          <div className="my-channel-title">
            <Typography variant="subheading" gutterBottom>
              {el.title}
            </Typography>
          </div>
          <div className="my-channel-status">
            <Typography variant="caption" gutterBottom>
              {el.status?el.status.text:null}
            </Typography>
          </div>
          <LinearProgress
            className="my-channel-progress-bar"
            variant="determinate"
            value={el.status?el.status.percentage:null}/>
        </div>
      </div>
    );
  });
};

export default MyChannels;



// WEBPACK FOOTER //
// ./src/containers/application/MyChannels.js